export function onFullfilledResponse(response) {
  // If response is fulfilled but data is null we need to reject the promise.
  // Then axios-retry will catch the error and retry the request.
  if (response.data === null) {
    return Promise.reject(response);
  }

  return response;
}
